import {
  DonutChart,
  BarChart,
  NMStatsTable,
  Col,
} from "@neumetric/blueprint-lib/components";
import { ExportSection } from "../ExportSection";
import { useSelector } from "react-redux";
import {
  getRemediatorStats,
  getCurrentDateRange,
} from "../../../store/central";

const MODULE_KEY = "Remediator_Department_vs_Compliance_Status";

export const RemediationDeptWiseStatsTable = () => {
  const remediatorStats = useSelector(getRemediatorStats);
  const currentDateRange = useSelector(getCurrentDateRange);
  const columns = remediatorStats.department.columns;
  const tableData = remediatorStats.department.tableData;
  const dateRangeLabel = currentDateRange ? currentDateRange.label : "";
  return (
    <ExportSection
      moduleKey={MODULE_KEY}
      index={1}
      dateRangeLabel={dateRangeLabel}
      exportType="table"
      exportData={{
        title: "Compliance - Department-wise",
        columns: columns,
        rows: tableData,
      }}
      style={{
        flex: "1 1 50%",
        maxWidth: "53%",
        padding: "20px 20px 20px 40px",
      }}
    >
      <NMStatsTable
        id="Remediator_Department_vs_Compliance_Status"
        dateRange={dateRangeLabel}
        showDateInHeader={true}
        title="Compliance"
        subTitle="Department-wise"
        columns={columns}
        dataSource={tableData}
      />
    </ExportSection>
  );
};

export const RemediationDeptWiseBarChart = () => {
  const remediatorStats = useSelector(getRemediatorStats);
  const currentDateRange = useSelector(getCurrentDateRange);
  const chartDatasets = remediatorStats.department.barData;
  const dateRangeLabel = currentDateRange ? currentDateRange.label : "";
  return (
    <ExportSection
      moduleKey={MODULE_KEY}
      index={2}
      dateRangeLabel={dateRangeLabel}
      exportType="chart"
      style={{
        flex: "1 1 45%",
        minWidth: 400,
        maxWidth: "50%",
        padding: "20px 40px 20px 0px",
        overflow: "visible",
      }}
    >
      <div
        className="chart-export-pad"
        style={{ width: "100%", overflow: "visible" }}
      >
        <div style={{ width: "100%", height: 500 }}>
          <BarChart
            id="Remediator_Department_vs_Compliance_Status"
            dateRange={dateRangeLabel}
            showDateInHeader={true}
            title="Compliance"
            subtitle="Department-wise"
            label={{ xAxis: "Tasks", yAxis: "Department" }}
            datasets={chartDatasets}
            stackType="normal"
            classes={{ root: "h-500-px w-90 mt-12" }}
          />
        </div>
      </div>
    </ExportSection>
  );
};

export const RemediationDeptWiseDonut = ({ mode }) => {
  const remediatorStats = useSelector(getRemediatorStats);
  const donutData = remediatorStats.department.donutData;
  const donutDatasetToTable = (donutData = []) => {
    const totals = {
      COMPLETE: 0,
      STARTED: 0,
      PENDING: 0,
      INVALID: 0,
    };
    donutData?.donutDatasets?.forEach((d) => {
      const key = d.key?.toUpperCase();
      if (key in totals) totals[key] += Number(d.value) || 0;
    });
    Object.keys(totals).forEach((k) => {
      totals[k] = Math.round(totals[k]) || 0;
    });
    const DonutColumns = [
      { title: "Complete", attribute: "COMPLETE" },
      { title: "Started", attribute: "STARTED" },
      { title: "Pending", attribute: "PENDING" },
      { title: "Other", attribute: "INVALID" },
      { title: "Compliance (%)", attribute: "COMPLIANCE" },
    ];
    const DonutRows = [
      {
        COMPLETE: totals.COMPLETE,
        STARTED: totals.STARTED,
        PENDING: totals.PENDING,
        INVALID: totals.INVALID,
        COMPLIANCE: `${donutData?.completionPct}%`,
      },
    ];

    return { DonutColumns, DonutRows };
  };
  const { DonutColumns, DonutRows } = donutDatasetToTable(donutData);

  return (
    <ExportSection
      moduleKey={MODULE_KEY}
      index={mode === "export_everything" ? 3 : 1}
      exportType={mode === "export_everything" ? "chart" : "table"}
      exportData={{
        title: "Compliance - Department-wise",
        columns: DonutColumns,
        rows: DonutRows,
      }}
      style={{
        display: "inline-block",
        width: 350,
        flex: "0 0 auto",
      }}
    >
      <Col style={{ width: 350 }}>
        <div
          style={{
            width: "100%",
            height: 200,
            paddingTop: "20px",
            paddingBottom: "0px",
          }}
          className={"remediation-donut"}
        >
          <DonutChart
            chartId="remediator-overall-donut"
            title="Compliance"
            subtitle="Tasks:"
            totalCount={String(donutData.totalOverall)}
            showDateInHeader={mode !== "fusion" ? true : false}
            classes={{ root: "h-200-px" }}
            datasets={donutData.donutDatasets}
            metric={{
              label: "Compliance",
              value: donutData.completionPct,
              type: "percent",
            }}
            style={{ width: "100%" }}
          />
        </div>
      </Col>
    </ExportSection>
  );
};
